module.exports = __webpack_public_path__ + "static/one_comm_home-83c46f185acd16a3afd8ad1ffa6282c2.jpg";